<section id="results" aria-live="polite">
    <h2 tabindex="0">Search Results</h2>
    <div class='row'id='row'>
      <ng-container *ngFor="let searchShoe of results">
        <div class="col-lg-4">
          <app-search-shoe-card [shoe]="searchShoe"></app-search-shoe-card>
        </div>
      </ng-container>
    </div>
</section>